const sanitizeId = (id: string) => id.replace(/[#.]/gi, "-");

export const getListItemId = (dropdownId: string, itemId: string) =>
  CSS.escape(`${sanitizeId(dropdownId)}-${sanitizeId(itemId)}`);
